var exports = {
  "tp": "x620889e6--7a2573--table",
  "ZW": "x620889e6--7a2573--switch",
  "AS": "x620889e6--7a2573--item",
  "RK": "x620889e6--7a2573--visible",
};

module.exports = exports;
